import { memo, useContext } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import { PageContext } from '../../../pages';

import { Head, PageTitle, MobileSubpages } from './mobile';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    background: theme.palette.primary.dark,
    height: '100%',
    paddingTop: theme.spacing(1)
  }
}));

const MobileHead = () => {
  const classes = useStyles();
  const { pageTitle, hasSubpages } = useContext(PageContext);

  return (
    <Box className={classes.container}>
      <Head />
      <PageTitle>{pageTitle}</PageTitle>
      {hasSubpages ? <MobileSubpages /> : null}
    </Box>
  );
};

export default memo(MobileHead);
